export default __webpack_public_path__ + "static/virtual-reality-banner-af692c6ea7dfb497504b5e3db00f76c9.webp";